import { AnalyticsEvent } from "@hermes/utils/analytics";

export interface GTMVirtualPageViewBase {
    event: string;
    pagetype: string;
    virtualpageuri?: string;
    eventLabel?: string;
}

export type VtoPageViewAnalyticsEventData = Omit<
    GTMVirtualPageViewBase,
    "event"
>;
/**
 * Abstract class for VtoPageview event
 */

export class VtoPageViewAnalyticsEvent
    implements AnalyticsEvent<GTMVirtualPageViewBase>
{
    /**
     * Event name expected for every event
     */
    public name: string = "virtualPageview";
    public eventData: VtoPageViewAnalyticsEventData;

    constructor(data: VtoPageViewAnalyticsEventData) {
        this.eventData = data;
    }

    /**
     * Return event formatted to send to GTM
     */
    public formatForGTM(): GTMVirtualPageViewBase {
        return {
            event: this.name,
            virtualpageuri: `${this.eventData.virtualpageuri}try-this-shade`,
            pagetype: `${this.eventData.pagetype}/vto`,
        };
    }
}
